export default __webpack_public_path__ + "static/media/screen3.8c572f21.png";